import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "@/shapeStorage/shapes/shape";
import { Shape } from "@/shapeStorage/shapes/shape";

export class ShapeIntermediateEvent extends Shape {
    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        const lineWidth = 1.5;
        const marginPercent = 0.15; // 15% от размера

        const oldLineWidth = canv.ctx.lineWidth;
        canv.ctx.lineWidth = lineWidth;

        // Вычисляем пропорциональный отступ
        const horizontalMargin = width * marginPercent;
        const verticalMargin = height * marginPercent;

        canv.ctx.beginPath();
        canv.ctx.ellipse(x + width / 2, y + height / 2, width / 2, height / 2, 0, 0, 2 * Math.PI);

        canv.ctx.moveTo(x + width - horizontalMargin, y + height / 2);
        canv.ctx.ellipse(
            x + width / 2,
            y + height / 2,
            width / 2 - horizontalMargin,
            height / 2 - verticalMargin,
            0,
            0,
            2 * Math.PI,
        );
        canv.ctx.closePath();

        canv.ctx.lineWidth = oldLineWidth;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        const strokeWidth = 1.5;
        const marginPercent = 0.15;

        const cx = width / 2;
        const cy = height / 2;
        const rx = width / 2 - strokeWidth / 2;
        const ry = height / 2 - strokeWidth / 2;

        const innerRx = rx - width * marginPercent;
        const innerRy = ry - height * marginPercent;

        return `<svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="${cx}" cy="${cy}" rx="${rx}" ry="${ry}" fill="${fill}" stroke="${stroke}"/>
            <ellipse cx="${cx}" cy="${cy}" rx="${innerRx}" ry="${innerRy}" fill="none" stroke="${stroke}"/>
        </svg>`;
    }
}
